import usersApi from '../../api/users-api';
import router from '@/router';

const users = {
  items: {},
  usersNumberCardData: {
    percent: '',
    number: '',
    type: '',
  },
  item: {},
  userActiveCardData: {
    number: '',
  },
  itemBarman: {},
  itemsBarmans: {},
};

const mutations = {
  setItems (state, payload) {
    state.items = payload.data;
    state.usersNumberCardData.percent = payload.meta.percent_last_month;
    state.usersNumberCardData.number = payload.meta.users_count;
    state.usersNumberCardData.type = 'down';
    if (payload.meta.percent_positive) {
      state.usersNumberCardData.type = 'up';
    }
  },
  setItem (state, payload) {
    state.item = payload;
  },
  setItemsBarmans (state, payload) {
    state.itemsBarmans = payload.data;
  },
  setItemBarman (state, payload) {
    state.itemBarman = payload;
  },
};

const actions = {
  async refreshUsers (context) {
    const res = await usersApi.getAll();
    context.commit('setItems', res.data);
  },
  createUser ({ commit, dispatch }, { user }) {
    commit('loading', true);
    usersApi.create(user).then(
      (response) => {
        commit('loading', false);
        commit('notifications', { title: 'user.UsuarioCreado' });
        commit('showNotifications', true);
        dispatch('refreshUsers');
      },
      (error) => {
        commit('loading', false);
        commit('notifications', { title: 'user.NotUsuarioCreado', text: error.response.data.message, color: 'danger' });
        commit('showNotifications', true);
      },
    );
  },
  editUser ({ commit, dispatch }, { id, user }) {
    commit('loading', true);
    usersApi.edit(id, user).then(
      (response) => {
        const recoveredUser = JSON.parse(localStorage.getItem('user'));
        commit('notifications', { title: 'user.UsuarioEditado' });
        if (recoveredUser.id == id) {
          dispatch('updateDataLogin', true);
        } else {
          location.reload();
        }
      },
      (error) => {
        commit('loading', false);
        if (error.response.data.email) {
            error.response.data.email.forEach(value => {
              commit('notifications', { title: 'user.NotUsuarioEditado', text: value, color: 'danger' });
            });
        } else {
          commit('notifications', { title: 'user.NotUsuarioEditado', text: error.response.data.message, color: 'danger' });
        }
        commit('showNotifications', true);
      },
    );
  },
  async getUser (context, userId) {
    context.commit('setItem', {});
    const res = await usersApi.getOne(userId);

    context.commit('setItem', res.data.data);
  },
  async refreshBarmans (context, { language, restaurant_id }) {
    if (!restaurant_id) {
      restaurant_id = this.getters.getCurrentRestaurant;
    }
    if (restaurant_id) {
      const res = await usersApi.getAllBarmansByRestaurant(restaurant_id, language);
      context.commit('setItemsBarmans', res.data);
    }
  },
  async getBarman (context, { id, language }) {
    context.commit('setItemBarman', {});
    context.commit('loading', true);
    usersApi.getOneBarman(id, language).then(
      (response) => {
        context.commit('setItemBarman', response.data.data);
        context.commit('loading', false);
      },
      (error) => {
        context.commit('notifications', { title: 'No se ha podido cargar el camarero', text: error.response.data.message, color: 'danger' });
        context.commit('loading', false);
        context.commit('showNotifications', true);
      },
    );
  },
  createBarman ({ commit }, { barman, language }) {
    commit('loading', true);
    usersApi.createBarman(barman, language).then(
      (response) => {
        commit('notifications', { title: 'barman.CamareroCreado' });
        commit('loading', false);
        router.push({ name: 'restaurant' });
        commit('showNotifications', true);
      },
      (error) => {
        let listMessages = [];
        Object.entries(error.response.data).forEach(([key, value]) => {
          value.forEach(
            item => {
              listMessages.push(item);
            });
         }
        );

        commit('loading', false);
        listMessages.forEach(message => {
          commit('notifications', { title: 'barman.NotCamareroCreado', text: message, color: 'danger' });
        })

        commit('showNotifications', true);
      },
    );
  },
  deleteBarman ({ commit, dispatch }, id) {
    commit('loading', true);
    usersApi.deleteBarman(id).then(
      (response) => {
        dispatch('refreshBarmans', { language: this.getters.getCurrentLanguage });
        commit('notifications', { title: 'barman.CamareroEliminado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'barman.NotCamareroEliminado', text: error.response.data.message, color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  activeBarman ({ commit, dispatch }, id) {
    commit('loading', true);
    usersApi.activeBarman(id).then(
      (response) => {
        dispatch('refreshBarmans', { language: this.getters.getCurrentLanguage });
        commit('notifications', { title: 'barman.CamareroActivado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'barman.NotCamareroActivado', text: error.response.data.message, color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  deactiveBarman ({ commit, dispatch }, id) {
    commit('loading', true);
    usersApi.deactiveBarman(id).then(
      (response) => {
        dispatch('refreshBarmans', { language: this.getters.getCurrentLanguage });
        commit('notifications', { title: 'barman.CamareroDesactivado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'barman.NotCamareroDesactivado', text: error.response.data.message, color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
  editBarman ({ commit }, { id, barman, language }) {
    commit('loading', true);
    usersApi.editBarman(id, barman, language).then(
      (response) => {
        router.push({ name: 'restaurant' });
        commit('notifications', { title: 'barman.CamareroEditado' });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', { title: 'barman.NotCamareroEditado', text: error.response.data.message, color: 'danger' });
        commit('loading', false);
        commit('showNotifications', true);
      },
    );
  },
};

const getters = {
  getUserActiveCardData: (state) => state.userActiveCardData,
  getUser: (state) => state.item,
  getBarman: (state) => state.itemBarman,
  getBarmans: (state) => state.itemsBarmans,
};

export default {
  state: users,
  mutations,
  actions,
  getters,
};
